module.exports = __webpack_public_path__ + "static/media/TheFutureIsNow2.03d848b7.png";